import Navbar from "../../components/Navbar/Navbar";
import LandingPageStyles from "./LandingPage.module.scss";
import { ReactNode } from "react";

interface Props {
  children?: ReactNode;
  showFooter?: boolean;
  haveRightContainer?: boolean;
}

const LandingPage = ({
  children,
  showFooter,
  haveRightContainer = true,
}: Props) => {
  return (
    <div className={LandingPageStyles.container}>
      <Navbar />
      {haveRightContainer ? (
        <div className={LandingPageStyles.rightContainer}>
          <div className={LandingPageStyles.content}>
            {children}
          </div>
        </div>
      ) : (
        children
      )}
    </div>
  );
};

export default LandingPage;
